import { render } from "./HigherSecondaryView.vue?vue&type=template&id=61251b3e"
import script from "./HigherSecondaryView.vue?vue&type=script&lang=js"
export * from "./HigherSecondaryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__